"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserType = exports.getUserData = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
function isArrayOfString(data) {
    if (!Array.isArray(data)) {
        return false;
    }
    return data.every((item) => typeof item === 'string');
}
function isIdJwt(data) {
    if (typeof data !== 'object' || !data) {
        return false;
    }
    const jwt = data;
    return (jwt.token_use === 'id' &&
        isArrayOfString(jwt['cognito:groups']) &&
        typeof jwt['custom:audience'] === 'string' &&
        typeof jwt.email === 'string' &&
        typeof jwt.email_verified === 'boolean' &&
        typeof jwt['custom:user_account_guid'] === 'string');
}
function decodeIdJwt(token) {
    const decodedJWT = (0, jwt_decode_1.default)(token);
    if (!isIdJwt(decodedJWT)) {
        throw new Error('ID JWT content is invalid');
    }
    return decodedJWT;
}
function getTypeFromCognitoGroups(groups) {
    // cascading if statements are used to make sure the function always work even if there are multiple groups or no matching group
    if (groups.includes('VERIFIED_MV_STAR')) {
        return { type: 'MV_STAR', verifiedUser: true };
    }
    if (groups.includes('MV_STAR')) {
        return { type: 'MV_STAR', verifiedUser: false };
    }
    if (groups.includes('VERIFIED_MEMBER')) {
        return { type: 'MEMBER', verifiedUser: true };
    }
    if (groups.includes('MEMBER')) {
        return { type: 'MEMBER', verifiedUser: false };
    }
    return { type: 'NEW', verifiedUser: false };
}
function getUserData({ guestID, idJWT, devID, userData }) {
    // JWT should be removed from this function when MFEs stop using it.
    const decodedJWT = idJWT ? decodeIdJwt(idJWT) : undefined;
    if (userData && userData.isLoggedIn) {
        return {
            identifier: userData.user.id,
            isLoggedIn: true,
            email: decodedJWT?.email || '',
            emailVerified: decodedJWT?.email_verified || false,
            audience: 'PUBLIC',
            type: userData.user.type,
            verifiedUser: userData.user.isVerified,
            devID,
        };
    }
    return {
        identifier: guestID,
        isLoggedIn: false,
        type: 'GUEST',
        audience: 'PUBLIC',
        devID,
    };
}
exports.getUserData = getUserData;
function getUserType(idJWT) {
    if (idJWT) {
        const decodedJWT = decodeIdJwt(idJWT);
        const { type } = getTypeFromCognitoGroups(decodedJWT['cognito:groups']);
        return type === 'NEW' ? 'UNKNOWN' : type;
    }
    return 'GUEST';
}
exports.getUserType = getUserType;
